// api/childApi.js
import apiClient, { downloadFile } from "../../../../../services/apiClient";

export const childApi = {
  getChildById: async (childId) => {
    const response = await apiClient.get(`children/${childId}`);
    return response.data && response.data[0];
  },

  verifyRegistration: async (childId, comment = '') => {
    const response = await apiClient.put(`children/${childId}/verify-registration`, {
      comment,
      verifiedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  setRegistrationManual: async (childId, comment = '') => {
    const response = await apiClient.put(`children/${childId}/set-registration-manual`, {
      comment,
      setBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  updateChildInfo: async (childId, updateData) => {
    const response = await apiClient.put(`children/${childId}`, updateData);
    return response.data;
  }
};

export const fileApi = {
  downloadFile: async (childId, fileId, path, fileName) => {
    await downloadFile(`children/${childId}/file/${fileId}/${path}`, fileName);
  }
};